import { render } from "./PreviousBlankHeader.vue?vue&type=template&id=67a150ad"
import script from "./PreviousBlankHeader.vue?vue&type=script&lang=js"
export * from "./PreviousBlankHeader.vue?vue&type=script&lang=js"

import "./PreviousBlankHeader.vue?vue&type=style&index=0&id=67a150ad&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__